/* Customer reviews, copied word for word from the #reviews channel in the
   Veyra Discord, with the poster's display name and the date they posted. The
   "+rep" tag most posts open with is left off; the words are theirs.

   Nothing here is written by us, edited for tone, or given a star rating the
   poster did not give -- the channel is "+rep" posts, not ratings, so there is
   no rating to publish and no aggregate to work out. Left out on purpose: a
   post calling the cheat "100% safe and unbannable", which contradicts what
   the site says about ban risk, and a feature request about smoothing that is
   not a review.

   `products` is set only when the post names the product. Those reviews are
   the only ones marked up on that product's page (Google: review markup has to
   be about the item and visible on the page); the rest are about the store and
   appear on the homepage as plain quotes. */

export type Review = {
  author: string;
  /** ISO date the post was made. */
  date: string;
  text: string;
  /** Game ids the post is about, when it names them. */
  products?: string[];
};

export const REVIEWS_SOURCE = "the #reviews channel in the Veyra Discord";

export const REVIEWS: Review[] = [
  {
    author: "A",
    date: "2026-10-02",
    text: "Literally the best store! The people running it are absolutely amazing. Beyond the great products and the store itself, they're genuinely awesome people. Their customer service is top-notch, they're extremely respectful and professional, and their response time is incredibly fast. Highly recommended!",
  },
  {
    author: "overseas",
    date: "2026-09-10",
    text: "Absolutely amazing service. The response time is very fast, and the support is honestly the best I've ever had. He's very friendly, generous, and always willing to help. Both the Deadlock external and CS2 external are very good, with tons of features and a really smooth overall experience. Definitely recommend this seller!",
    products: ["deadlock-external", "cs2-external"],
  },
  {
    author: "Kooky",
    date: "2026-09-13",
    text: "Been cheesing for a few years and these guys are down to earth and great at what they do. Highly prefer veyra over everything else I've used. Haven't had any real issues with my services and when there is it's fixed pretty quick! Bloody LEGENDS",
  },
  {
    author: "carter",
    date: "2026-09-26",
    text: "borat is the goat and it's a genuinley good cheat. plus monthy isnt that expensive at all for the quality.",
  },
  {
    author: "lordhighm",
    date: "2026-02-08",
    text: "+rep for borat the goat been using since game released and its never failed",
  },
  {
    author: "oobabooba",
    date: "2026-02-04",
    text: "Legit gaming chair. Over 780 games no ban restriction. Support always pretty fast when having trouble and Borat /aatrox on updates really quickly.",
  },
  {
    author: "John Clyde",
    date: "2026-02-04",
    text: "It's great. So many features. Highly recommend.",
  },
  {
    author: "bum",
    date: "2026-10-05",
    text: "owner goated and W updates!!!",
  },
];

export const reviewsFor = (gameId: string) => REVIEWS.filter((r) => r.products?.includes(gameId));

/** "2 Oct 2026" -- the same on the server and in every browser. */
export const reviewDate = (iso: string) =>
  new Date(`${iso}T12:00:00Z`).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  });
